export enum EApplyToOption {
  BRIEFCASE = 'briefcase',
  CART = 'cart',
}

export enum EWeekDay {
  MONDAY = 'monday',
  TUESDAY = 'tuesday',
  WEDNESDAY = 'wednesday',
  THURSDAY = 'thursday',
  FRIDAY = 'friday',
  SATURDAY = 'saturday',
  SUNDAY = 'sunday',
}

export enum ECreditActions {
  INCLUDE_CUSTOMERS = '2',
  EXCLUDE_CUSTOMERS = '1',
}
